import { render, staticRenderFns } from "./banking-form.vue?vue&type=template&id=50dbe51a&scoped=true"
import script from "./banking-form.vue?vue&type=script&lang=js"
export * from "./banking-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbe51a",
  null
  
)

export default component.exports